import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ISettings } from '../../../types/settings';

export enum ESetFavoriteListingType {
  Set = 'settings/favoriteListingType/set',
}

export type TSetFavoriteListingType = ITypedReduxAction<ESetFavoriteListingType.Set, ISettings['favoriteListingType']>;
